function formattedTags(dataSubmit) {
  if (dataSubmit?.tags?.length > 0 && Array.isArray(dataSubmit?.tags)) {
    const tags = dataSubmit.tags.map((tag) =>
      typeof tag === 'object' && tag.value ? tag.value : tag
    );
    dataSubmit.tags = tags;
  }
  return dataSubmit;
}

export default formattedTags;
